import { useCallback, useEffect } from "react";
import { useRequest } from "@apis/index";
import { getSupportContacts, type SupportContactsResponse } from "@apis/http/api";

/**
 * 「Contact Us」联系方式数据 hook。
 * 弹窗打开（enabled=true）且尚未成功加载时自动请求一次；不传 country，由后端按用户 biz_country 匹配。
 */
export const useSupportContacts = (enabled: boolean) => {
  const { status, error, data, request } = useRequest<
    Parameters<typeof getSupportContacts>[0],
    SupportContactsResponse
  >(getSupportContacts);

  const refetch = useCallback(() => request(undefined), [request]);

  useEffect(() => {
    if (enabled && status === "idle") {
      refetch();
    }
  }, [enabled, status, refetch]);

  return { status, error, data, refetch };
};
